import React from "react";
import { Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react'
import Zoom from 'react-reveal/Zoom';
import flash from '../Images/flash.png'
import robo from '../Images/robo.png'
import cro from '../Images/cro.png'
import bit from '../Images/bit.png'
import poop from '../Images/poop.png'
import cal from '../Images/cal.png'
import bro1 from '../Images/bro1.png'
import bro2 from '../Images/bro2.png'
import mus from '../Images/mus.png'
import bro6 from '../Images/bro6.png'
import bro7 from '../Images/bro7.png'
import atm from '../Images/atm.png'
import facedetect from '../Images/facedetect.png'
import registration from '../Images/registration.png'
import './Work.css'

const WorkMe = () => {
 
    return (
<>
<h1>My Work</h1>
<br />
<br />
<Tabs isLazy>
  <TabList>
    <Tab>As a Web Developer</Tab>
    <Tab>As a Programmer</Tab>
  </TabList>
  <TabPanels>
    {/* initially mounted */}
    <TabPanel>
    <Zoom>
   <section className="text-gray-600 body-font">
  <div className="container px-5 py-24 mx-auto">

    <div className="flex flex-wrap -m-4">
      <div className="xl:w-1/4 md:w-1/2 p-4">
        <div className="p-6 rounded-lg">
          <img className="h-52 rounded w-full object-cover object-center mb-6" src={flash} alt="content"/>
          <h2 className="text-lg text-rose-500 font-medium title-font mb-4">Flashing Guy</h2>
          <p className="leading-relaxed text-base">Full Stack Web App with Database for Face Detection along with signIn and SignUp Stuff </p>
          <a href="http://flashingguy.netlify.app/">
          <button className="dom pt-9"> View Project
</button>
</a>
        </div>
      </div>
      <div className="xl:w-1/4 md:w-1/2 p-4">
        <div className=" p-6 rounded-lg">
          <img className="h-40 rounded w-full object-cover object-center mb-6" src={robo} alt="content"/>
          <h2 className="text-lg text-rose-500 font-medium title-font mb-4">Folkbot</h2>
          <p className="leading-relaxed text-base">Simple Robot Api with Reactjs TouchUp</p>
          <a href="https://folkbotpy.herokuapp.com/">
          <button className="dom pt-9"> View Project
</button>
</a>
        </div>
      </div>
      <div className="xl:w-1/4 md:w-1/2 p-4">
        <div className=" p-6 rounded-lg">
          <img className="h-40 rounded w-full object-cover object-center mb-6" src={cro} alt="content"/>
          <h2 className="text-lg text-rose-500 font-medium title-font mb-4">Meet By Py</h2>
          <p className="leading-relaxed text-base">You can set your Meetup with this Nextjs project. Its a combination of Nextjs and Api technology.</p>
          <a href="https://meet-by-py.vercel.app/">
          <button className="dom pt-9"> View Project
</button>
</a>
        </div>
      </div>
      <div className="xl:w-1/4 md:w-1/2 p-4">
        <div className=" p-6 rounded-lg">
          <img className="h-44 rounded w-auto  object-center mb-6" src={bit} alt="content"/>
          <h2 className="text-lg text-rose-500 font-medium title-font mb-4">Bit Hobby</h2>
          <p className="leading-relaxed text-base">This Project is based on the 8-bit old Games like Mario. This Project is all about Me.</p>
          <a href="https://eightbit-res.vercel.app/">
          <button className="dom pt-9"> View Project
</button>
</a>
        </div>
      </div>
    </div>
  </div>
</section>
<section className="text-gray-600 body-font">
  <div className="container px-5  mx-auto">
    <div className="flex flex-wrap w-full ">
      <div className="lg:w-1/2 w-full mb-6 lg:mb-0">
      </div>
    </div>
    <div className="flex flex-wrap -m-4">
      <div className="xl:w-1/4 md:w-1/2 p-4">
        <div className="p-6 rounded-lg">
          <img className="h-48 rounded w-full object-center mb-6" src={poop} alt="content"/>
          <h2 className="text-lg text-rose-500 font-medium title-font mb-4">PooPayPy</h2>
          <p className="leading-relaxed text-base">Simple Portfolio Based Project with Database connected</p>
          <a href="https://poopaypy.herokuapp.com/">
          <button className="dom pt-9"> View Project
</button>
</a> 
        </div>
      </div>
      <div className="xl:w-1/4 md:w-1/2 p-4">
        <div className=" p-6 rounded-lg">
          <img className="h-40 rounded w-full object-cover object-center mb-6" src={cal} alt="content"/>
          <h2 className="text-lg text-rose-500 font-medium title-font mb-4">Calculator</h2>
          <p className="leading-relaxed text-base">As a the name suggests, It do Calculations.</p>
          <a href="https://calculateyoupy.herokuapp.com/">
          <button className="dom pt-9"> View Project
</button>
</a>
        </div>
      </div>
      <div className="xl:w-1/4 md:w-1/2 p-4">
        <div className=" p-6 rounded-lg">
          <img className="h-40 rounded w-full object-cover object-center mb-6" src={bro1} alt="content"/>
          <h2 className="text-lg text-rose-500 font-medium title-font mb-4">Background generator</h2>
          <p className="leading-relaxed text-base">Choose your gradient color for your Projects.</p>
          <a href="https://background-color-generator-py.vercel.app/">
          <button className="dom pt-9"> View Project
</button>
</a>
        </div>
      </div>
      <div className="xl:w-1/4 md:w-1/2 p-4">
        <div className=" p-6 rounded-lg">
          <img className="h-40 rounded w-full  object-center mb-6" src={bro2} alt="content"/>
          <h2 className="text-lg text-rose-500 font-medium title-font mb-4">To Do list</h2>
          <p className="leading-relaxed text-base">No Caption needed for this Project.</p>
       
          <a href="https://my-todoslist.vercel.app/">
          <button className="dom pt-9"> View Project
</button>
</a> </div>
      </div>
    </div>
  </div>
</section>
<section className="text-gray-600 body-font">
  <div className="container px-5  mx-auto">
    <div className="flex flex-wrap w-full ">
      <div className="lg:w-1/2 w-full mb-6 lg:mb-0">
      </div>
    </div>
    <div className="flex flex-wrap -m-4">
     
      <div className="xl:w-1/4 md:w-1/2 p-4">
        <div className=" p-6 rounded-lg">
          <img className="h-40 rounded w-full object-center mb-6" src={mus} alt="content"/>
          <h2 className="text-lg text-rose-500 font-medium title-font mb-4">Music Dude</h2>
          <p className="leading-relaxed text-base">Reactjs Based Project with Awesome UI for my Favourite Musics.</p>
          <a href="http://music-dude0191.herokuapp.com/">
          <button className="dom pt-9"> View Project
</button>
</a>
        </div>
      </div>
      <div className="xl:w-1/4 md:w-1/2 p-4">
        <div className=" p-6 rounded-lg">
          <img className="h-40 rounded w-full  object-center mb-6" src={bro6} alt="content"/>
          <h2 className="text-lg text-rose-500 font-medium title-font mb-4">Resume 1</h2>
          <p className="leading-relaxed text-base">Copy of my Resume</p>
          <a href="https://2nd-resume.vercel.app/">
          <button className="dom pt-9"> View Project
</button>
</a>
        </div>
      </div>
      <div className="xl:w-1/4 md:w-1/2 p-4">
        <div className=" p-6 rounded-lg">
          <img className="h-40 rounded w-full object-center mb-6" src={bro7} alt="content"/>
          <h2 className="text-lg text-rose-500 font-medium title-font mb-4">Resume 2</h2>
          <p className="leading-relaxed text-base">Another Copy of my Resume </p>
          <a href="https://resume-home.vercel.app/">
          <button className="dom pt-9"> View Project
</button>
</a>
        </div>
      </div>
    </div>
  </div>
</section>
</Zoom>
    </TabPanel>
    {/* initially not mounted */}
    <TabPanel>
      <Zoom>

    <section className="text-gray-600 body-font">
  <div className="container px-5 py-24 mx-auto">
    <div className="flex flex-wrap -m-4">
      <div className="xl:w-1/4 md:w-1/2 p-4">
        <div className=" p-6 rounded-lg">
          <img className="h-40 rounded w-full object-cover object-center mb-6" src={facedetect} alt="content"/>
          <h2 className="text-lg text-rose-500 font-medium title-font mb-4">FACE DETECTION</h2>
          <p className="leading-relaxed text-base">It is a Big project which i created while learning c++. although, it was a great experience to make something which i developed as web developer</p>
          <a href="https://www.youtube.com/watch?v=-LpeuutSpTw">
          <button className="dom pt-9"> View Project
</button>
</a>
        </div>
      </div>
      <div className="xl:w-1/4 md:w-1/2 p-4">
        <div className=" p-6 rounded-lg">
          <img className="h-40 rounded w-full object-cover object-center mb-6" src={atm} alt="content"/>
          <h2 className="text-lg text-rose-500 font-medium title-font mb-4">ATM</h2>
          <p className="leading-relaxed text-base">ATM is a simple program which i created where a user can check balance, do deposits or withdraw his/her balance. Well, its a mini project for my practice</p>
          <a href="https://replit.com/@piyushyadav0191/stm#main.cpp">
          <button className="dom pt-9"> View Project
</button>
</a>
        </div>
      </div>
      <div className="xl:w-1/4 md:w-1/2 p-4">
        <div className=" p-6 rounded-lg">
          <img className="h-40 rounded w-full object-cover object-center mb-6" src={registration} alt="content"/>
          <h2 className="text-lg text-rose-500 font-medium title-font mb-4">REGISTRATION
</h2>
          <p className="leading-relaxed text-base">It is a registration and login program where use can register themselves and then can login themselves. The best part of this project is that it create a file of username and password which user has created.</p>
          <a>
          <button className="dom pt-9"> View Project
</button>
</a>
        </div>
      </div>
     
    </div>
  </div>
</section>
</Zoom>
    </TabPanel>
  </TabPanels>
</Tabs>
<br />
<br />

</>
    )
}
export default WorkMe;